module.exports = __webpack_public_path__ + "static/media/30.b7253d6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/30.jpg
// module id = 720
// module chunks = 0